import { minLength, password, required } from "@src/utils/forms/validators";
import { FieldState, FormState } from "formstate";

export class FormChangePassword {
  old_password = new FieldState("").validators(required);
  new_password = new FieldState("").validators(
    required,
    minLength(8),
    password,
  );

  form = new FormState({
    old_password: this.old_password,
    new_password: this.new_password,
  });

  serialize() {
    return {
      old_password: this.old_password.$,
      new_password: this.new_password.$,
    };
  }
}
